module.exports = {
  "country": "CH",
  "artist": "Nemo",
  "song": "The Code",
  "year": "2024",
  "place": "1",
  "spotify": "1EjIXKhNHI00ZLMRpS8iz8"
};